import axios from 'axios'
import ApplicationController from '../application_controller.js'
import { isBlank, serialize } from '../../lib/utilities'

/*
 * Gestion des todos
 */

export default class Widget9Controller extends ApplicationController {

  add(e) {
    e.preventDefault()
    axios.get(e.target.href).then(response => {
      this.element.querySelector('div.thead').insertAdjacentHTML('afterend', response.data)
    })
  }

  reload(e) {
    axios.get(`${this.element.dataset.reloadPath}?${serialize(e.target.closest('form'))}`).then(response => {
      this.element.outerHTML = response.data
    })
  }

  edit(e) {
    e.preventDefault()
    axios.get(e.target.href).then(response => {
      this.element.outerHTML = response.data
    })
  }

  cancel(e) {
    e.preventDefault()
    e.stopImmediatePropagation() // Empêche le bubbling vers le controlleur widget9 englobant lors du outerHTML = '' - Raison ?

    if (isBlank(this.element.dataset.id)) {
      this.element.outerHTML = ''
    } else {
      axios.get(e.target.dataset.path).then(response => {
        this.element.outerHTML = response.data
      })
    }
  }

  submit(e) {
    e.preventDefault()

    axios({ url: e.target.action, method: e.target.method, data: new FormData(e.target) }).then(response => {
      this.element.outerHTML = response.data
    }).catch(error => {
      this.alert(error.response.data)
    })
  }

  destroy(e) {
    e.preventDefault()
    axios.delete(e.target.href).then(() => {
      this.element.outerHTML = ''
    })
  }

}